/**
 * Dual-format Brazilian CNPJ (aligned with loggi-web normalize_cnpj_for_storage / validate_cnpj_dual_format).
 * - Numeric: 14 digits with classic check digits (delegates to `cnpj` package for DV parity).
 * - Alphanumeric: 12 alphanumeric + 2 trailing digits (unmasked, uppercase letters).
 */

import { validate as validateCnpjNumeric } from 'cnpj';

const CNPJ_LENGTH = 14;

/**
 * @param {string} value – masked or unmasked
 * @returns {string}
 */
export function normalizeCnpjForStorage(value) {
  if (value == null || value === '') {
    return '';
  }
  const str = String(value).trim();
  const stripped = str.replace(/[.\-/]/g, '');
  return stripped.replace(/[a-z]/g, c => c.toUpperCase());
}

const SEGMENT_LENGTHS = [2, 3, 3, 4, 2];
const SEPARATORS = ['.', '.', '/', '-'];

/**
 * @param {string} body – unmasked body (max 14 chars)
 * @returns {string} display with Brazilian mask
 */
export function formatCnpjMask(body) {
  const b = body.slice(0, CNPJ_LENGTH);
  let out = '';
  let idx = 0;
  for (let s = 0; s < SEGMENT_LENGTHS.length && idx < b.length; s += 1) {
    const len = SEGMENT_LENGTHS[s];
    const chunk = b.slice(idx, idx + len);
    out += chunk;
    idx += chunk.length;
    if (idx < b.length && s < SEPARATORS.length) {
      out += SEPARATORS[s];
    }
  }
  return out;
}

export function isNumericCnpjValid(cnpj14) {
  if (!/^[0-9]{14}$/.test(cnpj14)) {
    return false;
  }
  return validateCnpjNumeric(cnpj14);
}

/**
 * @param {string} normalized – output of normalizeCnpjForStorage
 * @returns {boolean}
 */
export function isCnpjBrazilDualValid(normalized) {
  if (!normalized || normalized.length !== CNPJ_LENGTH) {
    return false;
  }
  if (!/^[A-Z0-9]{14}$/.test(normalized)) {
    return false;
  }
  if (/^[0-9]{14}$/.test(normalized)) {
    return isNumericCnpjValid(normalized);
  }
  return /^[A-Z0-9]{12}[0-9]{2}$/.test(normalized);
}
